document.addEventListener('DOMContentLoaded', () => {
	const forms = document.querySelectorAll('form')
	forms.forEach(form => {
		const select = form.querySelector('.acf-input select')
		const input = form.querySelector('.hidden')
		select.addEventListener('change', function () {
			if (this.value === 'Other') {
				input.classList.remove('hidden')
			} else {
				input.classList.add('hidden')
			}
		})
	})
})
